import { jsx } from 'react/jsx-runtime';
import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { EmptyComponent } from './EmptyComponent.js';
import { IconMobileSheet24KindFile } from '@fabric-app/icons/svg';

const EmptyFile = Node.create({
  name: "emptyFile",
  group: "block",
  atom: true,
  draggable: true,
  parseHTML() {
    return [
      {
        tag: "div[data-empty-image]"
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-empty-image": true
      })
    ];
  },
  addNodeView() {
    return ReactNodeViewRenderer((props) => /* @__PURE__ */ jsx(EmptyComponent, {
      ...props,
      type: "file",
      accept: "*",
      icon: /* @__PURE__ */ jsx(IconMobileSheet24KindFile, {}),
      label: "Upload a file"
    }));
  }
});

export { EmptyFile };
//# sourceMappingURL=EmptyFile.js.map
